<app-card label="Alert Messages" *ngIf="Messages?.length > 0">
      <div id="alert-message-content">
        <div class="short-sentence" *ngFor="let firstSentence of firstSentences">
          {{firstSentence}} <div class="link" [routerLink]="['alerts']" routerLinkActive="active">Read more</div>
        </div>
      </div>
</app-card>
